"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

require("./Hamburger.css");

var _hamburgerMenu = _interopRequireDefault(require("@sfly/uig-svg-icon/menu/hamburger-menu"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _close = _interopRequireDefault(require("@sfly/uig-svg-icon/action/close"));

var _helperUtil = require("../common/util/helperUtil");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var Hamburger = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Hamburger, _React$Component);

  var _super = _createSuper2(Hamburger);

  function Hamburger(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Hamburger);
    _this = _super.call(this, props);
    _this.toggleMenu = _this.toggleMenu.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Hamburger, [{
    key: "toggleMenu",
    value: function toggleMenu() {
      this.handleSmartBanner();
    }
    /**
     * This is the hack for not showing smartbanner when hamburger menu overlays smart banner
     *
     */

  }, {
    key: "handleSmartBanner",
    value: function handleSmartBanner() {
      this.props.callback();

      if (typeof document !== 'undefined' && document.getElementById('smartbanner')) {
        document.getElementById('smartbanner').style.display = this.props.isOpen ? 'block' : 'none';
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.props.isOpen;
      var ICON = isOpen ? _close.default : _hamburgerMenu.default;
      var accessibilityText = isOpen ? 'Close Hamburger Menu' : 'Open Hamburger Menu';
      return _react.default.createElement("div", {
        className: "uig-humburger-menu-wrapper"
      }, _react.default.createElement("div", {
        className: "uig-responsive-header-menu",
        "aria-label": accessibilityText,
        tabIndex: "0",
        role: "button",
        onClick: this.toggleMenu,
        onKeyPress: function onKeyPress(event) {
          return (0, _helperUtil.handleKeyPress)(event, function () {
            _this2.toggleMenu();
          });
        }
      }, _react.default.createElement(ICON, {
        className: 'uig-hamburger-menu-icon'
      })));
    }
  }]);
  return Hamburger;
}(_react.default.Component);

Hamburger.propTypes = {
  callback: _propTypes.default.func
};
Hamburger.defaultProps = {
  callback: function callback() {}
};
var _default = Hamburger;
exports.default = _default;